import { Section, TableOfContent } from '../../../typings/interfaces';
import { CHINESESIMPLIFIED } from '../../../assets/images';
// Chinese simplified
const ZHSection: Section[] = [
  {
    name: '1: 参考和概述',
    subSections: [
      {
        name: '前言',
        page: 3,
      },
      {
        name: '目的和现场指南应用',
        page: 4,
      },
      {
        name: '主要定义',
        page: 5,
      },
      {
        name: '分级控制措施',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFESavers',
    subSections: [
      {
        name: '机动车 - 交通安全',
        page: 9,
      },
      {
        name: '高空作业',
        page: 12,
      },
      {
        name: '移动动力设备 (MPE)',
        page: 18,
      },
      {
        name: '上锁和挂牌/能源隔离',
        page: 22,
      },
      {
        name: '电气作业',
        page: 25,
      },
      {
        name: '限制空间',
        page: 29,
      },
      {
        name: '散装货物和存储',
        page: 32,
      },
      {
        name: '轨道车安全',
        page: 37,
      },
      {
        name: '开挖作业',
        page: 41,
      },
      {
        name: '起重和吊装作业',
        page: 45,
      },
      {
        name: '危险物品',
        page: 49,
      },
      {
        name: '动火作业',
        page: 52,
      },
    ],
  },
  {
    name: '3: 其他资源和工具',
    subSections: [
      {
        name: '水上作业或水域附近作业',
        page: 56,
      },
      {
        name: '坠落物体',
        page: 59,
      },
      {
        name: '空气/气体检测',
        page: 61,
      },
      {
        name: '化学品危害沟通',
        page: 65,
      },
    ],
  },
  {
    name: '4: 嘉吉安全管理做法',
    subSections: [
      {
        name: '关键术语',
        page: 70,
      },
      {
        name: '严重伤害与死亡事故 (SIF) 判定',
        page: 72,
      },
      {
        name: '严重伤害与死亡潜在事故 (SIFp) 分类',
        page: 72,
      },
      {
        name: 'SIF 自主判定标准表',
        page: 74,
      },
      {
        name: '人员和组织绩效 (HOP)',
        page: 76,
      },
    ],
  },
];

const ZHTableOfContent: TableOfContent = {
  language: 'zh',
  sections: ZHSection,
  label: '目录',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (zh_CN)_CROPPED.pdf',
  hopPocket: 'HOP 口袋指南',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_zh_CN.pdf',
  source: CHINESESIMPLIFIED,
};

export default ZHTableOfContent;
